// extracted by mini-css-extract-plugin
export default {"component":"TopComponent_component__PITTI"};